module.exports = __webpack_public_path__ + "img/twitter_re.09bd52a4.svg";